// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.FDYsrxxbTODvBaB1mmUW {
  font-size: 14px;
  line-height: 20px;
  border-collapse: collapse;
  width: 100%;
  color: var(--main-color-text-first) !important;
}

.FDYsrxxbTODvBaB1mmUW th {
  text-align: center;
  font-weight: bold;
  background-color: var(--main-color-fourth) !important;
  backdrop-filter: blur(12px);
  padding: 8px;
  border-radius: 0px !important
}

.FDYsrxxbTODvBaB1mmUW td {
  cursor: pointer !important;
}

.FDYsrxxbTODvBaB1mmUW td, .FDYsrxxbTODvBaB1mmUW th {
  border: 1px solid #ccc;
  padding: 5px !important;
}

/* Survol des lignes du tableau */
.FDYsrxxbTODvBaB1mmUW tbody tr:hover {
  background-color: rgb(217,217,217,0.6);
}

.FDYsrxxbTODvBaB1mmUW input[type="checkbox"] {
  opacity: 1 !important;
  position: static !important;
  pointer-events: auto !important;
}


.Hq_01TCw4SOBKXss2it3 {
  position: sticky;
  top: 0;
  z-index: 9;
}

.D57lReKTz4U1GIexE5Lu {
  scrollbar-width: thin; 
  scrollbar-color: #2d7587 #e0e0e0; 
}

/* Pour Chrome, Edge, Safari */
.D57lReKTz4U1GIexE5Lu::-webkit-scrollbar {
  width: 8px; 
  height: 8px; 
}

.D57lReKTz4U1GIexE5Lu::-webkit-scrollbar-track {
  background: #f0f0f0; 
}

.D57lReKTz4U1GIexE5Lu::-webkit-scrollbar-thumb {
  background-color: var(--main-color-fourth) !important; 
  border-radius: 4px; 
  border: 2px solid #f0f0f0; 
}

.z27y0eY6B4yB5EuxWqM7 {
  margin-top: 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
}

.cANeoTHQq1yUyv4X4OB5 {
  display: flex;
  gap: 5px;
  align-items: center;
}

.zJ2nzzyCrlBnHdAtrZkL {
  padding: 4px 8px;
  font-size: 13px;
  border: 1px solid #ccc;
  background-color: #fff;
  border-radius: 4px;
  min-width: 30px;
  cursor: pointer;
  margin: 0 2px;
  transition: background-color 0.2s ease;
}

.zJ2nzzyCrlBnHdAtrZkL:hover:not(:disabled) {
  background-color: #f0f0f0;
}

.zJ2nzzyCrlBnHdAtrZkL:disabled {
  cursor: not-allowed;
  opacity: 0.5;
}

.zJ2nzzyCrlBnHdAtrZkL:focus {
  background-color: inherit;
  box-shadow: none;
  outline: none;
}

.kvN22hEtLL3RvO0gJbmi {
  font-weight: bold;
  background-color: var(--main-color-fourth) !important;
}

.MVjlbA8f3B7eWFYbyqqi{
  font-size: 13px;
  color: var(--main-color-text-first) !important;
}

/* Search row */
.r5C31vPcS_BX1lnB568q{
  display: flex;
  justify-content: flex-end; /* par défaut, tout à droite */
  align-items: center;
  margin-bottom: 10px;
}

.cwJVk3dnmOL6Q5CDkA85{
  margin-right: auto; /* pousse le reste à droite quand présent */
}

.fWJYn4ahmcOCGLA6yqsv{
  display: flex;
  align-items: center;
  gap: 8px;
}

.FFfQVsPI4ntJKdJdLjeW{
  display: flex;
  margin-bottom: 10px;
}

.Kkp5JNrFTbZks5dDBdVn{
  position: relative;
}

.q4FC0mkc0DNlQFMobCL5{
  background-color: #eee !important;
  border-radius: 5px !important;
  height: 30px !important;
  border: none !important;
  width: 220px !important;
  padding-left: 40px !important;
  font-size: 14px !important;
  margin-bottom: 0 !important;
}
.q4FC0mkc0DNlQFMobCL5:focus{
  border: none !important;
  box-shadow: none !important;
}

.ea256NIp2JcSFzpgEBYE{
  left: 10px;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  color: #000;
}

.pGx_H7OxaIZSiSCxLm1f {
  display: flex;
  align-items: center;
  gap: 5px;
  background: #f5f5f5;
  margin-bottom: 1px;
}

.ejPiq1QSJX4CTkzSF8lP {
  background: white;
  border: none;
  border-radius: 10px;
  cursor: pointer;
}

.ejPiq1QSJX4CTkzSF8lP:hover {
  background: #ccc !important;
}

.ejPiq1QSJX4CTkzSF8lP:focus {
  background: none !important;
}

.rSWYoJmDywtOL4K2fZlw{
  background: rgb(255,255,0,0.2) !important;
}`, "",{"version":3,"sources":["webpack://./src/component/resultat/resultatForm.module.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,iBAAiB;EACjB,yBAAyB;EACzB,WAAW;EACX,8CAA8C;AAChD;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,qDAAqD;EACrD,2BAA2B;EAC3B,YAAY;EACZ;AACF;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA,iCAAiC;AACjC;EACE,sCAAsC;AACxC;;AAEA;EACE,qBAAqB;EACrB,2BAA2B;EAC3B,+BAA+B;AACjC;;;AAGA;EACE,gBAAgB;EAChB,MAAM;EACN,UAAU;AACZ;;AAEA;EACE,qBAAqB;EACrB,gCAAgC;AAClC;;AAEA,8BAA8B;AAC9B;EACE,UAAU;EACV,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qDAAqD;EACrD,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,sBAAsB;EACtB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,aAAa;EACb,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,qDAAqD;AACvD;;AAEA;EACE,eAAe;EACf,8CAA8C;AAChD;;AAEA,eAAe;AACf;EACE,aAAa;EACb,yBAAyB,EAAE,8BAA8B;EACzD,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB,EAAE,2CAA2C;AACjE;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iCAAiC;EACjC,6BAA6B;EAC7B,uBAAuB;EACvB,uBAAuB;EACvB,uBAAuB;EACvB,6BAA6B;EAC7B,0BAA0B;EAC1B,2BAA2B;AAC7B;AACA;EACE,uBAAuB;EACvB,2BAA2B;AAC7B;;AAEA;EACE,UAAU;EACV,kBAAkB;EAClB,QAAQ;EACR,2BAA2B;EAC3B,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,yCAAyC;AAC3C","sourcesContent":[".customtable {\r\n  font-size: 14px;\r\n  line-height: 20px;\r\n  border-collapse: collapse;\r\n  width: 100%;\r\n  color: var(--main-color-text-first) !important;\r\n}\r\n\r\n.customtable th {\r\n  text-align: center;\r\n  font-weight: bold;\r\n  background-color: var(--main-color-fourth) !important;\r\n  backdrop-filter: blur(12px);\r\n  padding: 8px;\r\n  border-radius: 0px !important\r\n}\r\n\r\n.customtable td {\r\n  cursor: pointer !important;\r\n}\r\n\r\n.customtable td, .customtable th {\r\n  border: 1px solid #ccc;\r\n  padding: 5px !important;\r\n}\r\n\r\n/* Survol des lignes du tableau */\r\n.customtable tbody tr:hover {\r\n  background-color: rgb(217,217,217,0.6);\r\n}\r\n\r\n.customtable input[type=\"checkbox\"] {\r\n  opacity: 1 !important;\r\n  position: static !important;\r\n  pointer-events: auto !important;\r\n}\r\n\r\n\r\n.stickyHeader {\r\n  position: sticky;\r\n  top: 0;\r\n  z-index: 9;\r\n}\r\n\r\n.scrollablediv {\r\n  scrollbar-width: thin; \r\n  scrollbar-color: #2d7587 #e0e0e0; \r\n}\r\n\r\n/* Pour Chrome, Edge, Safari */\r\n.scrollablediv::-webkit-scrollbar {\r\n  width: 8px; \r\n  height: 8px; \r\n}\r\n\r\n.scrollablediv::-webkit-scrollbar-track {\r\n  background: #f0f0f0; \r\n}\r\n\r\n.scrollablediv::-webkit-scrollbar-thumb {\r\n  background-color: var(--main-color-fourth) !important; \r\n  border-radius: 4px; \r\n  border: 2px solid #f0f0f0; \r\n}\r\n\r\n.paginationContainer {\r\n  margin-top: 10px;\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  flex-wrap: wrap;\r\n}\r\n\r\n.paginationButtons {\r\n  display: flex;\r\n  gap: 5px;\r\n  align-items: center;\r\n}\r\n\r\n.paginationButton {\r\n  padding: 4px 8px;\r\n  font-size: 13px;\r\n  border: 1px solid #ccc;\r\n  background-color: #fff;\r\n  border-radius: 4px;\r\n  min-width: 30px;\r\n  cursor: pointer;\r\n  margin: 0 2px;\r\n  transition: background-color 0.2s ease;\r\n}\r\n\r\n.paginationButton:hover:not(:disabled) {\r\n  background-color: #f0f0f0;\r\n}\r\n\r\n.paginationButton:disabled {\r\n  cursor: not-allowed;\r\n  opacity: 0.5;\r\n}\r\n\r\n.paginationButton:focus {\r\n  background-color: inherit;\r\n  box-shadow: none;\r\n  outline: none;\r\n}\r\n\r\n.paginationButtonActive {\r\n  font-weight: bold;\r\n  background-color: var(--main-color-fourth) !important;\r\n}\r\n\r\n.paginationtext{\r\n  font-size: 13px;\r\n  color: var(--main-color-text-first) !important;\r\n}\r\n\r\n/* Search row */\r\n.ctnActionMenu{\r\n  display: flex;\r\n  justify-content: flex-end; /* par défaut, tout à droite */\r\n  align-items: center;\r\n  margin-bottom: 10px;\r\n}\r\n\r\n.leftActions{\r\n  margin-right: auto; /* pousse le reste à droite quand présent */\r\n}\r\n\r\n.actionsRightGroup{\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n}\r\n\r\n.searchRow{\r\n  display: flex;\r\n  margin-bottom: 10px;\r\n}\r\n\r\n.searchInputCtn{\r\n  position: relative;\r\n}\r\n\r\n.searchInput{\r\n  background-color: #eee !important;\r\n  border-radius: 5px !important;\r\n  height: 30px !important;\r\n  border: none !important;\r\n  width: 220px !important;\r\n  padding-left: 40px !important;\r\n  font-size: 14px !important;\r\n  margin-bottom: 0 !important;\r\n}\r\n.searchInput:focus{\r\n  border: none !important;\r\n  box-shadow: none !important;\r\n}\r\n\r\n.searchIcon{\r\n  left: 10px;\r\n  position: absolute;\r\n  top: 50%;\r\n  transform: translateY(-50%);\r\n  color: #000;\r\n}\r\n\r\n.bulkActionBar {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 5px;\r\n  background: #f5f5f5;\r\n  margin-bottom: 1px;\r\n}\r\n\r\n.bulkActionButton {\r\n  background: white;\r\n  border: none;\r\n  border-radius: 10px;\r\n  cursor: pointer;\r\n}\r\n\r\n.bulkActionButton:hover {\r\n  background: #ccc !important;\r\n}\r\n\r\n.bulkActionButton:focus {\r\n  background: none !important;\r\n}\r\n\r\n.selectedRow{\r\n  background: rgb(255,255,0,0.2) !important;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"customtable": `FDYsrxxbTODvBaB1mmUW`,
	"stickyHeader": `Hq_01TCw4SOBKXss2it3`,
	"scrollablediv": `D57lReKTz4U1GIexE5Lu`,
	"paginationContainer": `z27y0eY6B4yB5EuxWqM7`,
	"paginationButtons": `cANeoTHQq1yUyv4X4OB5`,
	"paginationButton": `zJ2nzzyCrlBnHdAtrZkL`,
	"paginationButtonActive": `kvN22hEtLL3RvO0gJbmi`,
	"paginationtext": `MVjlbA8f3B7eWFYbyqqi`,
	"ctnActionMenu": `r5C31vPcS_BX1lnB568q`,
	"leftActions": `cwJVk3dnmOL6Q5CDkA85`,
	"actionsRightGroup": `fWJYn4ahmcOCGLA6yqsv`,
	"searchRow": `FFfQVsPI4ntJKdJdLjeW`,
	"searchInputCtn": `Kkp5JNrFTbZks5dDBdVn`,
	"searchInput": `q4FC0mkc0DNlQFMobCL5`,
	"searchIcon": `ea256NIp2JcSFzpgEBYE`,
	"bulkActionBar": `pGx_H7OxaIZSiSCxLm1f`,
	"bulkActionButton": `ejPiq1QSJX4CTkzSF8lP`,
	"selectedRow": `rSWYoJmDywtOL4K2fZlw`
};
export default ___CSS_LOADER_EXPORT___;
